import { useEffect } from "react";
import { getRootNode } from "../utils/get-root-node.es.js";
const allowedEvents = ["keydown", "mousedown", "touchstart"];
function useOnEventOutside(refs, events, handler) {
  useEffect(() => {
    const refList = Array.isArray(refs) ? refs : [refs];
    const listener = (event) => {
      const targetRootNode = getRootNode(event.target);
      const isInside = refList.some(
        (ref) => ref && ref.current && ref.current.contains(event.target)
      );
      const hasCommonRoot = refList.some(
        (ref) => ref && ref.current && getRootNode(ref.current) === targetRootNode
      );
      if (!isInside && (!targetRootNode || hasCommonRoot)) {
        handler(event);
      }
    };
    const filteredEvents = events.filter(
      (event) => allowedEvents.indexOf(event) > -1
    );
    filteredEvents.map((event) => document.addEventListener(event, listener));
    return () => {
      filteredEvents.map(
        (event) => document.removeEventListener(event, listener)
      );
    };
  }, [events, handler, refs]);
}
export {
  useOnEventOutside
};
